<template>
  <div class="dlrActivity-item">
    <h3 class="dlrActivity-item-tit"><span>活动介绍</span></h3>
    <div class="dlrActivity-item-con">
      <div class="dlrActivity-item-paragraph" v-html="content"></div>
      <template v-if="imageArray && imageArray.length > 0">
        <img
          :key="imgIndex"
          v-for="(imgItem, imgIndex) in imageArray"
          :src="imgItem.replace('http://', 'https://')"
        />
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    imageArray: {
      type: Array,
      default: function () {
        return [];
      }
    }
  }
};
</script>
<style lang="scss">
</style>